import { LimitedAccessTypes } from './limited-access';
import {MojoWellKnownNames} from "@feature/common";

export class UserSettings {
  ClientFilterName: string;
  ClientRef: number;
  ClientParentRef: number;
  IsInPreviewMode: boolean;
  IsInMyDashboardMode: boolean;
  BrandName: string;
  ShouldShowClientDashboardLink: boolean;
  Product: string;
  MojoPlatformUserId: number;
  LicensedProducts: MojoWellKnownNames.Product[];
  LinkedToMultipleCreditors: boolean;
  EnabledAddOns: string[];
  ActualProduct: string;
  PmaWindowAuditName: string;
  PmaAuditModuleCode: string;
  LinkedCreditor: number;
  MojoFormsBaseUrl: string;
  Permissions: string[];
  LimitedAccess: LimitedAccessTypes;
  FaqEnabled: boolean;
}
